export enum PortTariffLineTypes {
  STANDARD = 'standard',
  TAX = 'tax',
}
